import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { HaccpReportsComponent } from './haccp-reports.component';

const routes: Routes = Route.withShell([
  {
    path: 'haccpreports',
    component: HaccpReportsComponent,
    data: { title: 'HACCP Reports' },
    children: [
      { path: '', redirectTo: 'hccp-dashboard', pathMatch: 'full' },
      {
        path: 'hccp-dashboard',
        loadChildren: () => import('./hccp-dashboard/hccp-dashboard.module').then((module) => module.HccpDashboardModule)
      },
      {
        path: 'create-report',
        loadChildren: () => import('./create-report/create-report.module').then((module) => module.CreateReportModule)
      }
    ]
  }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports:[RouterModule],
  declarations: []
})
export class HaccpReportsRoutingModule { }
